import Article from '../modules/Article';
Article.init();
